import React from 'react'
import pt from 'prop-types'
import noop from 'lodash/noop'
import memoWithName from '@/hocs/memoWithName'
import useSvgColors from '@/hooks/useSvgColors'

const LightBulbIcon = ({ color, onClick }) => {
  const {
    fill,
  } = useSvgColors(color)
  return (
      <svg onClick={onClick} width="18" height="18" viewBox="0 0 18 18" fill={fill} xmlns="http://www.w3.org/2000/svg"> 
        <use href='/sprite.svg#light'></use>
      </svg>
  )
}

LightBulbIcon.propTypes = {
  onClick: pt.func,
  color: pt.string,
}
LightBulbIcon.defaultProps = {
  onClick: noop,
  color: null,
}

export default memoWithName(LightBulbIcon)
